import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const CreditSafeCompanyReportDataSchema = z
    .object({
        riskScore: z.number().optional(),
        creditLimit: z.number().optional(),
        creditLimitCurrency: z.string().optional(),
        complianceAlerts: z.number().optional(),
        dbt: z.number().optional(), // Days Beyond Terms
        paymentExperiences: z.number().optional(),
        paymentTrend: z.enum(['low', 'medium', 'high']).optional(),
        inquiresTrend: z.enum(['low', 'medium', 'high']).optional(),
        creditRiskScore: z.number().optional(),
        creditRiskLevel: z.enum(['Low risk', 'Medium risk', 'High risk']).optional(),
        insuranceStatus: z.string().optional(),
        summary: z.string().optional(),
        rawData: z.any().optional(), // Complete raw report data
    })
    .strict();

export class CreditSafeCompanyReportData extends FromSchema(CreditSafeCompanyReportDataSchema) {
    riskScore?: number;
    creditLimit?: number;
    creditLimitCurrency?: string;
    complianceAlerts?: number;
    dbt?: number; // Days Beyond Terms
    paymentExperiences?: number;
    paymentTrend?: 'low' | 'medium' | 'high';
    inquiresTrend?: 'low' | 'medium' | 'high';
    creditRiskScore?: number;
    creditRiskLevel?: 'Low risk' | 'Medium risk' | 'High risk';
    insuranceStatus?: string;
    summary?: string;
    rawData?: any; // Complete raw report data
}
